export enum TipoEquipo {
    none,
    'Amigo Kit',
    'Amigo Chip',
    'Equipo Propio',
    'Otro',
}